export const GROUPS_REQUEST = "GROUPS_REQUEST";
export const GROUPS_SUCCESS = "GROUPS_SUCCESS";
export const GROUPS_FAIL = "GROUPS_FAIL";

export const GROUPS_CLEAR_ERRORS = "GROUPS_CLEAR_ERRORS";
